export default "https://static.zego.com/_next/static/chunks/fonts/ModernEra-Regular-c2b53b4b44ebc4a3f5ef2630022069d7.woff2";